import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={26}
    height={29}
    viewBox="0 0 26 29"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#fff'}
      fillRule="evenodd"
      d="M15.3.05c1.05 0 2.09.11 3.11.34a12.57 12.57 0 0 0-6.84 9.2c-.67 3.99.62 8.05 3.47 10.92 2.85 2.87 6.9 4.2 10.9 3.56-3.27 3.6-8.13 5.3-12.93 4.53-4.8-.77-8.88-3.92-10.84-8.37A14.371 14.371 0 0 1 15.31.05h-.01Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
